import { render } from "./ApprovedHeading.vue?vue&type=template&id=4bbda0b8"
import script from "./ApprovedHeading.vue?vue&type=script&lang=js"
export * from "./ApprovedHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__